import { useEffect } from 'react'

import { useBoundStore } from '../store/store'
import type { ComponentsResponse } from '../store/types/components'
import { api } from '../utils/api-client'

const useComponents = () => {
  const setIsLoading = useBoundStore(state => state.components.setIsLoading)
  const setComponents = useBoundStore(state => state.components.setComponents)
  const username = useBoundStore(state => state.user.username)

  useEffect(() => {
    const controller = new AbortController()

    const fetchComponents = async () => {
      setIsLoading(true)
      try {
        const res = await api.get<ComponentsResponse>(
          '/components.php',
          { username },
          { signal: controller.signal },
        )
        if (res.data) {
          setComponents(res.data)
        }
      } catch (error) {
        console.error(error)
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false)
        }
      }
    }

    fetchComponents()

    return () => {
      controller.abort()
    }
  }, [username])
}

export default useComponents
